var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.402 18.22C5.28 11.262 11.04 5.523 18 5.4c6.958-.12 12.477 5.423 12.598 12.38.121 6.956-5.64 12.697-12.598 12.817-6.958.122-12.477-5.423-12.598-12.378z",
    stroke: "#0077BE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 12.599a.75.75 0 0 0-1.5 0v4.65H12.6a.75.75 0 0 0 0 1.5h4.65v4.65a.75.75 0 0 0 1.5 0v-4.65h4.65a.75.75 0 0 0 0-1.5h-4.65v-4.65z",
    fill: "#0077BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.b4fc72c6dc509fdbee6ad1cd609c29ec.svg";
export { ForwardRef as ReactComponent };